export default __webpack_public_path__ + "static/geomanist-regular-webfont-260f60c2a3bf7905d4e4f582856375c7.woff2";